module.exports = __webpack_public_path__ + "img/claiming-property.3804eb48.png";